class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    this.delay = Math.max(Number(this.dataset.delay) || 60, 60) * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true", 30);
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    if (this.closed === "true" || this.subscribed === "true" || this.popupScheduled) return;
    this.popupScheduled = true;
    this.delayElapsed = false;
    this.hasEngaged = false;

    const openWhenEngaged = () => {
      if (!this.delayElapsed || !this.hasEngaged || document.hidden) return;
      if (this.hasOpened || getCookie("newsletter-closed") === "true" || getCookie("newsletter-subscribed") === "true") return;
      this.hasOpened = true;
      this.show();
      window.removeEventListener("scroll", this.handleEngagedScroll);
      document.removeEventListener("visibilitychange", this.handlePopupVisibilityChange);
    };

    this.handleEngagedScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= 0.4) {
        this.hasEngaged = true;
        openWhenEngaged();
      }
    };

    window.addEventListener("scroll", this.handleEngagedScroll, { passive: true });
    this.handlePopupVisibilityChange = openWhenEngaged;
    document.addEventListener("visibilitychange", this.handlePopupVisibilityChange);
    this.handleEngagedScroll();
    this.popupTimer = setTimeout(() => {
      this.delayElapsed = true;
      openWhenEngaged();
    }, this.delay);
  }

  disconnectedCallback() {
    clearTimeout(this.popupTimer);
    window.removeEventListener("scroll", this.handleEngagedScroll);
    document.removeEventListener("visibilitychange", this.handlePopupVisibilityChange);
    this.popupScheduled = false;
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true", 365);
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

